import { choices } from "../../../service/forms/config-generics/aeKao";

export function getTamarikiList() {
  const tamarikiMax = 20;
  const tamarikiList = [];
  let tamarikiCount = 1;

  while (tamarikiCount < tamarikiMax) {
    const visibleIf =
      tamarikiCount === 1
        ? "true"
        : `{tamaiti${tamarikiCount - 1}FirstName} notempty`;
    const requiredIf = `{tamaiti${tamarikiCount}FirstName} notempty`;
    const requiredIfName = `{tamaiti${tamarikiCount + 1}FirstName} notempty`;

    tamarikiList.push(
      {
        type: "text",
        title: `Tamaiti ${tamarikiCount}: First Name`,
        name: `tamaiti${tamarikiCount}FirstName`,
        placeHolder: "Ingoa",
        visibleIf,
        requiredIf: requiredIfName,
      },
      {
        type: "text",
        title: `Tamaiti ${tamarikiCount}: Middle Names`,
        name: `tamaiti${tamarikiCount}MiddleNames`,
        placeHolder: "Ingoa Waenganui",
        visibleIf,
        startWithNewLine: false,
      },
      {
        type: "text",
        title: `Tamaiti ${tamarikiCount}: Surname`,
        name: `tamaiti${tamarikiCount}Surname`,
        placeHolder: "Ingoa Whānau",
        visibleIf,
        startWithNewLine: false,
        requiredIf,
      },
      {
        type: "text",
        inputType: "date",
        name: `tamaiti${tamarikiCount}Dob`,
        title: `Tamaiti ${tamarikiCount}: Date of Birth`,
        visibleIf: requiredIf,
        validators: [
          {
            type: "expression",
            expression: `age({tamaiti${tamarikiCount}Dob}) < 18`,
            text: "Adults 18 or over must register separately as themselves",
          },
        ],
        requiredIf,
      },
      {
        type: "radiogroup",
        title: `Tamaiti ${tamarikiCount}: Gender`,
        name: `tamaiti${tamarikiCount}Gender`,
        choices: ["Wahine", "Tāne", "Ira Weherua-kore"],
        visibleIf: requiredIf,
        startWithNewLine: false,
        requiredIf,
      },
      {
        type: "radiogroup",
        title: `Tamaiti ${tamarikiCount}: Whāngai`,
        name: `tamaiti${tamarikiCount}Whangai`,
        choices,
        visibleIf: requiredIf,
        startWithNewLine: false,
        requiredIf,
      }
    );

    tamarikiCount += 1;
  }

  return tamarikiList;
}
